
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Templates() {
  const navigate = useNavigate();

  const templates = [
    {
      title: 'Air Waybill',
      description: 'Extract data from air cargo documents and shipping manifests',
      icon: 'ri-plane-line',
      route: '/templates/air-waybill'
    },
    {
      title: 'Invoice',
      description: 'Parse invoices and billing documents for financial data',
      icon: 'ri-file-text-line',
      route: '/templates/invoice'
    },
    {
      title: 'Purchase Order',
      description: 'Extract purchase order information and line items',
      icon: 'ri-shopping-cart-line',
      route: '/templates/purchase-order'
    },
    {
      title: 'Bill of Lading',
      description: 'Process shipping documents and cargo manifests',
      icon: 'ri-ship-line',
      route: '/templates/bill-of-lading'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <Navbar showUserActions={true} />
      
      <div className="px-4 py-6">
        <Button variant="outline" onClick={() => navigate('/home')} className="mb-6">
          <i className="ri-arrow-left-line mr-2"></i>
          Back to Home
        </Button>
      </div>
      
      <div className="flex flex-col items-center px-4">
        <div className="w-full max-w-6xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-800 mb-2">Templates</h1>
            <p className="text-xl text-gray-600 mb-4">Select a Prebuilt Template</p>
            <div className="w-full h-px bg-gray-300"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {templates.map((template, index) => (
              <Card key={index} onClick={() => navigate(template.route)} className="h-full">
                <div className="flex flex-col h-full">
                  <div className="flex items-start mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-indigo-100 mr-4 flex-shrink-0">
                      <i className={`${template.icon} text-xl text-indigo-600`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">{template.title}</h3>
                      <p className="text-gray-600 text-sm">{template.description}</p>
                    </div>
                  </div>
                  
                  <div className="mt-auto pt-4 border-t border-gray-200">
                    <Button variant="primary" className="w-full whitespace-nowrap">
                      View Schema
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
